export default "__VITE_ASSET__zV7tUP8a__"